export enum PropertyBoxType {
    RECOMMENDED = "recommended",
    MAIN = "main"
}
